import { createAsyncThunk, isRejectedWithValue } from '@reduxjs/toolkit';
import authApi from '~/apis/auth';

import { CREATE_CANVAS_TOKEN, GET_PROFILE, LOGIN, LOGIN_WITH_URL } from '~/utils/constants/actionType';
import { IBodyLogin } from '~/utils/interface/auth';

export const handleLogin = createAsyncThunk(
  LOGIN,
  async (
    payload: {
      body: IBodyLogin;
    },
    { rejectWithValue }
  ) => {
    try {
      const resp = await authApi.login(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getProfile = createAsyncThunk(GET_PROFILE, async (payload: string, { rejectWithValue }) => {
  try {
    // const resp = await authApi.getProfile(payload);
    // return resp.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const handleLoginWithUrl = createAsyncThunk(LOGIN_WITH_URL, async (_, { rejectWithValue }) => {
  try {
    const res = await authApi.getLoginUrl();
    return res.data.data.url;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createCanvasToken = createAsyncThunk(
  CREATE_CANVAS_TOKEN,
  async (payload: { code: string; state?: string }, { rejectWithValue }) => {
    try {
      const res = await authApi.createCanvasToken(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
